import React, { useState, useEffect, useMemo } from "react";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import JsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import { IMAGE_URL, TABLE_DATE_TIME_FORMAT } from "../../../utils/Constants";
import { GetIntakeProcessDetailCancelToken, getIntakeProcessDetail } from "../../../services/copyIntakeServices";
import DataTableComponent from "../../common/DataTableComponent";
import { InitialRender } from "../../common/Helper";
import Hover from "../../common/Hover";
import { Link } from "react-router-dom";
import axios from "axios";

const ProcessDetail = ({ id, setShowProcessDetail }) => {

    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);
    const [studentList, setStudentList] = useState([]);
    const [deleteRow, setDeleteRow] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [tableState, setTableState] = useState({
        page: 1,
        perPage: 10,
        sortKey: "time",
        sortOrder: "desc",
    });

    useEffect(() => {
        const cancelTokenSources = [];
        const getData = async () => {
            setLoading(true);

            cancelTokenSources.forEach(source => {
                source.cancel('New request made');
              });
          
              const source = axios.CancelToken.source();
              cancelTokenSources.push(source);

            const data = {
                uniqueProcessId: id,
                page: tableState.page,
                limit: tableState.perPage,
                key: tableState.sortKey,
                sort: tableState.sortOrder,
                search: search,
            };

            try {
                const res = await GetIntakeProcessDetailCancelToken(data, source.token);
                setShowProcessDetail(res?.data && res?.data?.list && res?.data?.list?.data.length || search ? true : false)
                setStudentList(
                    res?.data && res?.data?.list && res?.data?.list?.data ? res?.data?.list?.data : []
                );
                setTotalRows(res?.data?.list?.total);
                if (res.status === 200) {
                  setLoading(false);
                }
              } catch (error) {
                if (!axios.isCancel(error)) {
                  console.error(error);
                  setLoading(false);
                }
              }
        };
        getData();

        return () => {
            cancelTokenSources.forEach(source => {
              source.cancel('Component unmounted');
            });
        };
    }, [
        deleteRow,
        tableState,
        // totalRows,
        search,
    ]);

    const columns = useMemo(() => [
        {
            name: "Code",
            selector: "uniqueProcessId",
            sortField: "uniqueProcessId",
            sortable: true,
            cell: (row) => (
                <span
                    className="as-text-blue font-weight-bold feature-name"
                    title={row.uniqueProcessId}
                //   to={`/courseAdministration/articulation/open-articulation-registration/open/${row.id}?description=${row.description}`}
                >
                    <span className="textLimit100">{row.uniqueProcessId}</span>
                </span>
            ),
        },
        {
            name: "From Intake",
            selector: "From_intake",
            sortField: "From_intake",
            sortable: true,
            cell: (row) => row.From_year + " - " + row.From_intake,
        },
        {
            name: "To Intake",
            selector: "To_intake",
            sortField: "To_intake",
            sortable: true,
            cell: (row) => row.To_year + " - " + row.To_intake,
        },
        {
            name: "Created By",
            selector: "Firstname",
            sortField: "Firstname",
            sortable: true,
            cell: (row) => (
                <div className="assigned-title-block-new">
                    <div className="assigned-title-itm">
                        <span className="assigned-title-blk  name-icon cat-dark-red">
                            {row.picture_me ? (
                                <img
                                    src={`${IMAGE_URL}/${row.picture_me.replaceAll(
                                        "/home/myaie/public_html/",
                                        ""
                                    ).replace("public/", "")}`}
                                    alt="AIE"
                                />
                            ) : (
                                InitialRender([row.Firstname, row.Lastname])
                            )}
                            <span className={`profile-box-2-status ${row.created_by_activity_status ? row.created_by_activity_status.toLowerCase() == "online" ? "Online" : row.created_by_activity_status.toLowerCase() == "away" ? "Away" : "Offline" : "Offline"}`}>
                                <i className="fas fa-circle"></i>
                            </span>
                            <Hover
                                firstName={row?.Firstname}
                                lastName={row?.Lastname}
                                photo={row?.picture_me}
                                email={row?.Email}
                                mobile={row.Mobile}
                                status={row.created_by_status}
                                activity_status={row?.created_by_activity_status}
                                right={true}
                                // showNumber={true}
                                // number={row.student_crm_id}
                            />
                        </span>
                        <Link
                            className="as-text-blue curser feature-name"
                            to={`/systemAdministration/userManagement/open/${row.user_id}/aboutYou`}
                            title={row.Firstname + " " + row.Lastname}
                        >
                            <span className="textLimit100">{row.Firstname + " " + row.Lastname}</span>
                        </Link>
                    </div>
                </div>
            ),
        },
        {
            name: "Created At",
            selector: "time",
            sortField: "time",
            sortable: true,
            cell: (row) => (
                <>
                    {row.time ? (
                        <div className="">
                            <p className="right-space">
                                {moment(row.time).format(TABLE_DATE_TIME_FORMAT)}
                            </p>
                        </div>
                    ) : (
                        "-"
                    )}
                </>
            ),
        },
    ]);

    const exportData = (fileType, fileName) => {
        let data;
        const header = ["Code", "From Intake", "To Intake", "Created By", "Created At"];
        const details = {
            uniqueProcessId: id,
            page: tableState.page,
            limit: tableState.perPage,
            key: tableState.sortKey,
            sort: tableState.sortOrder,
            search: search,
            exportStatus: "true",
        };
        GetIntakeProcessDetailCancelToken(details)
            .then((res) => {
                data = res?.data && res?.data?.list?.length ? res?.data?.list : [];
                data = data?.map((row) => ({
                    ...row,
                    "Code": row.uniqueProcessId ? row.uniqueProcessId : "-",
                    "From Intake": row?.From_intake && row.From_year ? row.From_year + " - " + row.From_intake : "-",
                    "To Intake": row?.To_intake && row?.To_year ? row.To_year + " - " + row.To_intake : "-",
                    "Created By": row.Firstname ? row.Firstname + " " + row.Lastname : "-",
                    "Created At": row.time ? moment(row.time).format(TABLE_DATE_TIME_FORMAT) : "-",
                }));
                if (fileType === "csv") {
                    const csvString = Papa.unparse({ fields: header, data });
                    const blob = new Blob([csvString], {
                        type: "text/csv;charset=utf-8,",
                    });

                    const blobURL = window.URL.createObjectURL(blob);

                    const anchor = document.createElement("a");
                    anchor.download = fileName;
                    anchor.href = blobURL;
                    anchor.dataset.downloadurl = [
                        "text/csv",
                        anchor.download,
                        anchor.href,
                    ].join(":");
                    anchor.click();

                    setTimeout(() => {
                        URL.revokeObjectURL(blobURL);
                    }, 1000);
                } else if (fileType === "xlsx") {
                    const compatibleData = data.map((row) => {
                        const obj = {};
                        header.map((col, index) => {
                            obj[col] = row[col];
                        });
                        return obj;
                    });

                    let wb = XLSX.utils.book_new();
                    let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
                        header,
                    });
                    XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
                    XLSX.writeFile(wb, `${fileName}.xlsx`);

                    return false;
                }
                if (fileType === "pdf") {
                    const compatibleData = data.map((row) => {
                        return [
                            row["Code"],
                            row["From Intake"],
                            row["To Intake"],
                            row["Created By"],
                            row["Created At"],
                        ];
                    });
                    const doc = new JsPDF();
                    doc.autoTable({
                        head: [header],
                        body: compatibleData,
                        styles: {
                            minCellHeight: 10,
                            minCellWidth: 5,
                            halign: "left",
                            fontSize: 8,
                        },
                    });
                    doc.save(`${fileName}.pdf`);

                    return false;
                }
            })
            .catch((error) => {
                console.log("error =-=--> ", error);
                setLoading(false);
            });
    };

    return (
        <DataTableComponent
            data={studentList}
            loading={loading}
            state={tableState}
            setState={setTableState}
            setSearch={setSearch}
            totalRows={totalRows}
            columns={columns}
            exportFunction={exportData}
            exportFileName={"Process_Details"}
        />
    );
};

export default ProcessDetail;
